export default __webpack_public_path__ + "static/revolutionizing-logistics-booking-management-5137125ba1fce2aa568f1fe5769d2bdf.png";